module.exports = __webpack_public_path__ + "static/media/border-outer.1eb18779.svg";